import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class SizeForm extends Component {
	constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            sizeInEdit: this.props.dataItem || null,
            originalSize: this.props.dataItem.Description || '',
            value: [],
            sizeMessage: ''
		};
	}

	componentDidMount() {
		
	}

	handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.disabled) {
            return;
        }
        this.setState({ disabled: true });

		if (this.state.originalSize != this.state.sizeInEdit.Description) {
            axios
				.get(`${ROOT_API_URL}/ManageSizes/IsSizeExist?sizeName=${this.state.sizeInEdit.Description}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
						sizeMessage: response.data.message,
						disabled: false 
                    });

                    if (this.state.sizeMessage == '') {
                        this.props.save({
                            ...this.state.sizeInEdit
                        });
                        
                        this.props.cancel();
                    }
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {
            this.props.save({
                ...this.state.sizeInEdit
            });
            this.setState({ disabled: false });
            this.props.cancel();
        }
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.sizeInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
            sizeInEdit: edited,
            sizeMessage: ''
		});
    };
    
    
	render() {
		return (
			<Dialog onClose={this.props.cancel}>
			{console.log(this.state,"size state")}
				{!this.state.sizeInEdit.SizeOptionID ?
                    <h2 className="adjust-dist-title">Add New Size</h2> :
                    <h2 className="adjust-dist-title">Edit Size</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="Description">Size Description</label>
						<Input
							required={true}
							type="text"
							name="Description"
							id="Description"
							value={this.state.sizeInEdit.Description || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.sizeMessage}</p>
					</div>
				
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{/* {console.log('this.state.userInEdit', this.state.userInEdit)} */}
								{!this.state.sizeInEdit.SizeOptionID ? (
                                    <button type="submit" className="admin-k-button" disabled={this.state.disabled}>
										<i className="fas fa-save"></i>
                                        <span>{this.state.disabled ? 'SAVING...' : 'SAVE'}</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button" disabled={this.state.disabled}>
										<i className="fas fa-edit"></i>
                                        <span>{this.state.disabled ? 'UPDATING...' : 'UPDATE'}</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default connect(null, {  })(SizeForm);
